<template>
  <div id="principaisClientesExpo">
    <loading color="#2185d0" :active.sync="isLoading" loader="bars" :is-full-page="fullPage"></loading>
    <grafico-linha :chart-data="dados_grafico" :options="options"></grafico-linha>
  </div>
</template>
     
<script>
import GraficoLinha from "src/components/graficos/GraficoLinha.vue";

export default {
  name: "principaisClientesExpo",
  props: ["estatisticaInfo"],
  components: {
    GraficoLinha
  },
  data() {
    return {
      isLoading: false,
      fullPage: false,
      dados_grafico: {},
      options: {
        plugins: {
          // Change options for ALL labels of THIS CHART
          datalabels: {
            display: false
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              stacked: true,
              ticks: {
                beginAtZero: true,
                min: 0
              }
            }
          ],
          xAxes: [
            {
              stacked: true,
              ticks: {
                fontSize: 10,
                align: "end"
              }
            }
          ]
        }
      }
    };
  },
  methods: {
    getPrincipaisClientesExpo(data) {
      let url =
        this.$urlApi + "/api/estatisticas-principais-clientes-exportacao";
      this.isLoading = true;
      this.axios.post(url, data).then(res => {
        //console.log(res.data);
        this.dados_grafico = {
          labels: res.data.label,
          datasets: [
            {
              label: "Principais Clientes Exportação",
              borderColor: "#6699FF",
              data: res.data.series,
              fill: false
            }
          ]
        };
        this.isLoading = false;
      });
    }
  },
  watch: {
    $props: {
      handler() {
        this.getPrincipaisClientesExpo(this.$props.estatisticaInfo);
      },
      deep: true
    }
  }
};
</script>

<style>
</style>